import PagedElements from '@/models/paged/pagedelements';
import POSMatrixTemplateLinkListViewModel from '@/models/view/posmatrixtemplatelinklistviewmodel';

export default class PagedPOSMatrixTemplateLinks extends PagedElements<POSMatrixTemplateLinkListViewModel> {
    constructor(init?: Partial<PagedPOSMatrixTemplateLinks>) {
        super(init);
    }
}
